import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from 'utils/services';

import {
  DeleteDocumentsReqProps,
  DeleteDocumentsResProps,
  EditDocumentsReqProps,
  EditDocumentsResProps,
  GetDocumentsReqProps,
  GetDocumentsResProps,
  UploadDocumentsReqProps,
  UploadDocumentsResProps
} from './documents.types';

export const documentsApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    deleteDocument: build.mutation<DeleteDocumentsResProps, DeleteDocumentsReqProps>({
      query: ({ accessToken, documentId, sourcePage }) => ({
        method: 'DELETE',
        ...(accessToken && {
          headers: {
            Authorization: accessToken
          }
        }),
        body: { sourcePage },
        url: `documents/${documentId}/mark-deleted`
      })
    }),
    editDocument: build.mutation<EditDocumentsResProps, EditDocumentsReqProps>({
      query: ({ description, documentId }) => ({
        body: { description },
        method: 'PATCH',
        url: `documents/${documentId}`
      })
    }),
    getDocuments: build.query<GetDocumentsResProps, GetDocumentsReqProps>({
      keepUnusedDataFor: 0,
      query: (rawParams) => {
        const { accessToken, pageNo, ...params } = rawParams ?? {};
        return {
          ...(accessToken && {
            headers: {
              Authorization: accessToken
            }
          }),
          params: {
            limit: 10,
            ...params,
            pageNo: Math.max(0, Math.floor(Number(pageNo ?? 0)))
          },
          url: '/documents/list'
        };
      }
    }),
    uploadDocuments: build.mutation<UploadDocumentsResProps, UploadDocumentsReqProps>({
      query: ({ accessToken, body }) => ({
        ...(accessToken && {
          headers: {
            Authorization: accessToken
          }
        }),
        body,
        method: 'POST',
        url: '/documents/upload'
      })
    })
  }),
  reducerPath: 'documentsApi',
  tagTypes: ['Documents']
});

export const {
  useDeleteDocumentMutation,
  useEditDocumentMutation,
  useGetDocumentsQuery,
  useLazyGetDocumentsQuery,
  useUploadDocumentsMutation
} = documentsApi;
